import { PalmettoIcon } from '@palmetto/dsm-components';
import { Link } from 'react-router-dom';

interface EquipmentBreadcrumbProps {
  /** Rendered as the trailing, non-navigable crumb. Omit on the Manufacturers list itself. */
  current?: string;
}

const linkClass = 'text-text-primary no-underline hover:underline';

export const EquipmentBreadcrumb = ({ current }: EquipmentBreadcrumbProps) => (
  <div className="flex flex-row flex-wrap items-center gap-4 body-200 text-text-secondary">
    <Link to="/admin/approved-vendors" className={linkClass}>
      Approved Vendors
    </Link>
    <PalmettoIcon name="chevronRight" size="sm" />
    {current ? (
      <>
        <Link to="/admin/approved-vendors/manufacturers" className={linkClass}>
          Manufacturers
        </Link>
        <PalmettoIcon name="chevronRight" size="sm" />
        <span className="text-text-tertiary">{current}</span>
      </>
    ) : (
      <span className="text-text-tertiary">Manufacturers</span>
    )}
  </div>
);
